import React, {ReactElement, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHtmlIframe} from '../../../../hooks/useHtmlIFrame';
import {IElementHtml} from '../../../../incase-domain/elements/html';
import {IRunFile} from '../../../../incase-domain/proptypes/runfile';
import {jumpToSlideWithIdAction} from '../../../../store/actions/presentation.actions';
import {runFileCustomVarsOnlySelector} from '../../../../store/selectors/runfile.selectors';

interface ElementHtmlProps {
    element: IElementHtml;
}

function ElementHtml(props: ElementHtmlProps): ReactElement {
    const {element} = props;
    const {slideChange} = element;
    const runfileWithCustomVars = useSelector(runFileCustomVarsOnlySelector);
    const dispatch = useDispatch();
    const wrapperRef = useRef<HTMLDivElement>(null);

    const propagateClick = (): void => {
        wrapperRef.current?.click();
    };

    const {containerRef} = useHtmlIframe(element, runfileWithCustomVars as IRunFile, propagateClick);

    return (
        <div
            ref={wrapperRef}
            style={{width: '100%', height: '100%'}}
            onClick={() => slideChange?.slideId && dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}
        >
            <div
                style={{
                    background: element.color,
                    color: element.fontColor,
                    width: '100%',
                    height: '100%',
                }}
                className="c-textElement"
                id={`html-id-${element.id}`}
                ref={containerRef}
            />
        </div>
    );
}

export default ElementHtml;
